<!DOCTYPE html>
<html lang="pt-br">
<head>
    <meta charset="UTF-8">
    <title>Valores</title>
</head>
<body>
    <section>
        <div class="content">
            <div class="textBox">
                <h2>Valores</h2>
                <br/>
                <p>Reutilização, bem-estar, empatia, ecologia, boa ação e repasse de bens materiais.</p>
                <a class="btn mt-4" href="">A equipe</a>
            </div>
            <div class="imgBox">
                <img src="https://imgur.com/pckA2Er.jpg.png" width="550" height="550" class="imagem1">
            </div>
        </div>
    </section>
</body>
</html> 